import moment from "moment";
const colors = ["#8a3ea7", "#2b84d2", "#b02621", "#de352f"];

export const getRandomColor = () => colors[Math.floor(Math.random() * colors.length)];

export const getIntialsFromString = (str) => {
    if (!str || typeof str !== "string") return str;
    const names = str.split(" ");
    return names[0][0] + names[1][0];
};

export const getFormatedDate = (date, format = "MMM DD, YYYY") => moment(date).format(format);

// this function is not necessary because in getFormatedDate you can pass the format as argumnet
// export const getFormatedDate2 = (date, format = "YYYY/MMM/DD") => moment(date).format(format);

export const getFormattedTimeStamp = (date, format = " h:mm a") => moment(date).format(format);


// export const normalizePrice = (price) => {
//   if (typeof price === "number") {
//     return { single: price, family: null }; // Treat scalar as single price
//   }
//   if (typeof price === "string") {
//     try {
//       const parsed = JSON.parse(price);
//       return { single: parsed.single, family: parsed.family || null };
//     } catch (error) {
//       console.error("Failed to parse price string:", price);
//       return { single: null, family: null }; // Fallback
//     }
//   }
//   if (typeof price === "object" && price !== null) {
//     return { single: price.single, family: price.family || null };
//   }
//   return { single: null, family: null }; // Fallback for invalid price
// };

// utils/constants.js
export const normalizePrice = (price) => {
  try {
    if (typeof price === "string") {
      // Handle stringified JSON (e.g., "{\"single\":72000,\"family\":288000}")
      const parsed = JSON.parse(price);
      return {
        single: parsed.single || "N/A",
        family: parsed.family || "N/A",
      };
    } else if (typeof price === "object" && price !== null) {
      // Handle object (e.g., { single: 290570, family: 1162260 })
      return {
        single: price.single || "N/A",
        family: price.family || "N/A",
      };
    } else if (typeof price === "number") {
      // Handle single number (e.g., 15000)
      return {
        single: price,
        family: "N/A", // Assume family price is not applicable
      };
    }
    // Fallback for invalid or missing price
    return {
      single: "N/A",
      family: "N/A",
    };
  } catch (error) {
    console.error("Error normalizing price:", error, price);
    return {
      single: "N/A",
      family: "N/A",
    };
  }
};